export default "__VITE_ASSET__09c79ff0__"